module.exports = __webpack_public_path__ + "static/media/logo_dark.4d8acea6.png";